import { useNavigate } from "react-router-dom";
import ButtonComponent from "../../components/ui/button.component";
import { ROUTES } from "../../routing/routes";
import NotFoundIcon from "../../styles/icons/404.svg";
import NotFounfImage from "../../styles/icons/not-found-page-image.svg";
import * as styled from "./styled";

function NotFoundPage() {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate(ROUTES.HOME);
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <styled.NotFoundPageContainer>
      <styled.NotFoundPageWrapper>
        <styled.StyledNotFounfImage src={NotFounfImage} alt="not-found-img" />
        <styled.NotFoundPageContent>
          <styled.NotFoundIcon src={NotFoundIcon} alt="not-found-icon" />
          <styled.Title>Сторінку не знайдено</styled.Title>
          <styled.Subtitle>
            На жаль, запитувана сторінка не існує або була переміщена.{" "}
          </styled.Subtitle>

          <styled.ActionsContainer>
              <ButtonComponent text='На головну' position='bottom-right' onClick={handleGoHome}/>
              <ButtonComponent text='Повернутись назад' position='top-right' variant="outline" onClick={handleGoBack}/> 
          </styled.ActionsContainer>
        </styled.NotFoundPageContent>
      </styled.NotFoundPageWrapper>
    </styled.NotFoundPageContainer>
  );
}

export default NotFoundPage;
